import { FilterBar, SearchInput, Select } from './styled';

interface CounterpartyFilterBarProps {
  search: string;
  onSearchChange: (val: string) => void;
  typeFilter: string;
  onTypeFilterChange: (val: string) => void;
  sourceFilter: string;
  onSourceFilterChange: (val: string) => void;
  verifiedFilter: string;
  onVerifiedFilterChange: (val: string) => void;
}

export function CounterpartyFilterBar({
  search,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  sourceFilter,
  onSourceFilterChange,
  verifiedFilter,
  onVerifiedFilterChange,
}: CounterpartyFilterBarProps) {
  return (
    <FilterBar>
      <SearchInput
        placeholder="Поиск по наименованию, ИНН, БИК или номеру счёта…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <Select value={typeFilter} onChange={(e) => onTypeFilterChange(e.target.value)}>
        <option value="all">Все типы контрагентов</option>
        <option value="supplier">Поставщики</option>
        <option value="subcontractor">Субподрядчики</option>
        <option value="customer">Заказчики</option>
        <option value="leasing">Лизинговые компании</option>
        <option value="bank">Банки</option>
        <option value="tax_authority">ФНС / Налоги</option>
        <option value="other">Прочее</option>
      </Select>
      <Select value={sourceFilter} onChange={(e) => onSourceFilterChange(e.target.value)}>
        <option value="all">Все источники</option>
        <option value="1c_api">1С (API)</option>
        <option value="1c_statement">1С (Выписка банка)</option>
        <option value="1c_document">1С (Документ)</option>
        <option value="excel">Excel импорт</option>
        <option value="contracts">Договоры</option>
        <option value="manual">Ручной ввод</option>
      </Select>
      <Select value={verifiedFilter} onChange={(e) => onVerifiedFilterChange(e.target.value)}>
        <option value="all">Все статусы верификации</option>
        <option value="verified">Проверенные 1С</option>
        <option value="unverified">Требуют уточнения</option>
      </Select>
    </FilterBar>
  );
}
